import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Paper, Typography, IconButton, LinearProgress, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { getUploadProgress } from '../../../store/global/selectors';
import { removeUploadProgress } from '../../../store/global/actions';
import { getDetailsFromUrl } from '../../../services/blueprint';

const useStyles = makeStyles((theme) => ({
    greenProgress: {
        backgroundColor: '#d0f0d0',
        '& .MuiLinearProgress-barColorPrimary': {
            backgroundColor: 'green',
        },
    },
    uploadHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    }
}));

const UploadNotifications = () => {
    const uploads = useSelector(getUploadProgress);
    const dispatch = useDispatch();
    const classes = useStyles();

    const { blueprintId } = getDetailsFromUrl();

    const filteredUploads = uploads.filter(item => item.blueprint_id == blueprintId);

    const cancelUpload = (id) => {
        dispatch(removeUploadProgress({ id }));
    }

    const formatTime = (seconds) => {
        if (seconds === null || isNaN(seconds)) return '';
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m > 0 ? `${m}m ` : ''}${s}s`;
    };


    return (
        <div style={{
            position: 'fixed',
            bottom: 10,
            right: 10,
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            width: 300
        }}>
            {filteredUploads.map((upload) => {
                console.log(`Rendering ${upload.fileName} with progress ${upload.progress}`);
                return (
                    <Paper key={upload.id} style={{ padding: 12, position: 'relative' }} id={`upload_notification_${upload.fileName}`}>
                        <div className={classes.uploadHeader} style={upload.status === 'completed' ? { paddingRight: 30 } : {}}>
                            <Typography variant="body2" noWrap title={upload.fileName}>
                                {upload.fileName}
                            </Typography>
                            {upload.status === 'uploading' && (
                                <Typography variant="caption" color="textSecondary">
                                    {upload.progress}%
                                </Typography>
                            )}
                            {upload.status === 'completed' && <IconButton
                                size="small"
                                onClick={() => cancelUpload(upload.id)}
                                style={{ position: 'absolute', top: 4, right: 4 }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>}
                        </div>

                        {upload.status === 'uploading' && (
                            <>
                                <LinearProgress
                                    variant="determinate"
                                    value={upload.progress}
                                    className={classes.greenProgress}
                                    style={{ marginTop: 8 }}
                                />
                                {upload.progress === 100 &&
                                    <Typography variant="caption" color="textSecondary">
                                        Processing..
                                    </Typography>
                                }
                            </>
                        )}

                        {upload.status === 'completed' && (
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 8, color: 'green' }}>
                                <CheckCircleOutlineIcon fontSize="small" id={"check_circle_icon"}/>
                                <Typography variant="caption" style={{ marginLeft: 4 }}>Completed</Typography>
                            </div>
                        )}

                        {upload.status === 'error' && (
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 8, color: 'red' }}>
                                <ErrorOutlineIcon fontSize="small" />
                                <Typography variant="caption" style={{ marginLeft: 4 }}>Failed</Typography>
                            </div>
                        )}
                    </Paper>
                )
            })}
        </div>
    );
};

export default UploadNotifications;
